import Vue from 'vue'
import { formatDateTime } from './util'

Vue.filter('formatDate', function (date) {
  if (date === undefined) {
    return '';
  }
  let dateAux;
  dateAux = date.replace(/\D/g, '');
  dateAux = dateAux.replace(/(\d{4})(\d{2})(\d{2})(\d*)/, '$3/$2/$1');
  return dateAux;
})

Vue.filter('formatDateTime', formatDateTime)

Vue.filter('formatNumber', function (value) {
  if (value === undefined || Number.isNaN(value)) {
    return '0,0';
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(value).replace(/(R\$)*(\s)*/g, '').substring(0, 3);
})